import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import ThemeAccessor from '../themeAccessor/ThemeAccessor';
var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    var calculatedTheme = useMemo(function () { return theme instanceof ThemeAccessor ? theme : new ThemeAccessor(theme); }, [theme]);
    // ToDo: change into useState
    // ToDo: support MediaQuery using react-responsive (prevent unnecessary re rendering)
    return (React.createElement(StyledComponentsThemeProvider, { theme: calculatedTheme }, children));
};
export default observer(ThemeProvider);
//# sourceMappingURL=ThemeProvider.js.map